import { Form as InertiaForm } from '@inertiajs/react'
import { type ComponentProps, useEffect, useState } from 'react'

import { CategoryType } from './types'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { Textarea } from '@/components/ui/textarea'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import {Button} from "@/components/ui/button.tsx";

type FormProps = Omit<ComponentProps<typeof InertiaForm>, 'children'> & {
  category: CategoryType
  submitText: string
  communities?: {
    id: string
    name: string
  }[]
}

const statusOptions = [
  { value: 'active', label: 'Active' },
  { value: 'inactive', label: 'Inactive' },
] as const

export default function Form({
  category,
  submitText,
  communities = [],
  ...formProps
}: FormProps) {
  const initialStatus = category.status || 'active'
  const initialCommunityId = category.community_id || communities[0]?.id || ''
  const [status, setStatus] = useState(initialStatus)

  useEffect(() => {
      setStatus(initialStatus)
  }, [initialStatus, initialCommunityId])

  return (
    <InertiaForm
      transform={data => ({ category: data })}
      className="contents"
      {...formProps}
    >
      {({ errors, processing }) => (
        <>
          <div className="my-2">
            <Label htmlFor="name">Name</Label>
            <Input
              id="name"
              name="name"
              defaultValue={category.name}
              placeholder="Category name"
            />
            {errors.name && (
              <div className="text-red-500 px-3 py-2 font-medium">
                {errors.name.join(', ')}
              </div>
            )}
          </div>

          <div className="my-2">
            <Label htmlFor="description">Description</Label>
            <Textarea
              id="description"
              name="description"
              defaultValue={category.description}
              placeholder="Describe this category"
            />
            {errors.description && (
              <div className="text-red-500 px-3 py-2 font-medium">
                {errors.description.join(', ')}
              </div>
            )}
          </div>

            <div className="my-2">
              <Label htmlFor="status">Status</Label>
              <input type="hidden" name="status" value={status} />
              <Select value={status} onValueChange={setStatus}>
                <SelectTrigger id="status" className={"w-full"}>
                  <SelectValue placeholder="Status" />
                </SelectTrigger>
                <SelectContent>
                  {statusOptions.map((option) => (
                    <SelectItem key={option.value} value={option.value}>
                      {option.label}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
              {errors.status && (
                <div className="text-red-500 px-3 py-2 font-medium">
                  {errors.status.join(', ')}
                </div>
              )}

          </div>

          <div className="inline">
            <Button
              type="submit"
              disabled={processing}
                 >
              {submitText}
            </Button>
          </div>
        </>
      )}
    </InertiaForm>
  )
}
